var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.743,
    height: 30.486,
    viewBox: "0 0 31.743 30.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M14.147,3.545l.951.309-.951-.309-2.139,6.584a1,1,0,0,1-.951.691H4.134a3,3,0,0,0-1.763,5.427l5.6,4.069a1,1,0,0,1,.363,1.118L6.2,28.017a3,3,0,0,0,4.617,3.354l5.6-4.069a1,1,0,0,1,1.176,0l5.6,4.069A3,3,0,0,0,27.8,28.017l-2.139-6.584a1,1,0,0,1,.363-1.118l5.6-4.069a3,3,0,0,0-1.763-5.427H22.943a1,1,0,0,1-.951-.691L19.853,3.545A3,3,0,0,0,14.147,3.545Z",
    transform: "translate(-1.128 -1.472)",
    fill: "#f9c306"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldStar);
export default __webpack_public_path__ + "static/media/gold-star.dd72064c38033ba4ba7ca3f413056c13.svg";
export { ForwardRef as ReactComponent };